import { renderBoolean } from 'KnmPackage/KnmHistoriesModule/common/renderBoolean';
import { renderConfirmingMaterialNumber } from 'KnmPackage/KnmHistoriesModule/common/renderConfirmingMaterialNumber';
import { renderDate } from 'KnmPackage/KnmHistoriesModule/common/renderDate';

export const getViolationsHistoryFields = (name: string) => ({
  [`/${name}/status`]: {
    name: 'Статус нарушения',
    active: true,
  },
  [`/${name}/description`]: {
    name: 'Описание нарушения',
    active: true,
  },
  [`/${name}/notRemoval`]: {
    name: 'Нарушение не подлежит устранению',
    active: true,
    renderFunc: renderBoolean,
  },
  [`/${name}/correctedInEvent`]: {
    name: 'Нарушение устранено в ходе мероприятия',
    active: true,
    renderFunc: renderBoolean,
  },
  [`/${name}/inEvent`]: {
    name: 'Выявлено в рамках действия',
    active: true,
    renderFunc: renderBoolean,
  },
  [`/${name}/corrected`]: {
    name: 'Нарушение устранено',
    active: true,
    renderFunc: renderBoolean,
  },
  [`/${name}/appealed`]: {
    name: 'Нарушение обжаловано',
    active: true,
    renderFunc: renderBoolean,
  },
  [`/${name}/explanation`]: {
    name: 'Пояснение к нарушению',
    active: true,
  },
  [`/${name}/dateResolvedByAgreement`]: {
    name: 'Дата устранения по соглашению',
    active: true,
    renderFunc: renderDate,
  },

  [`/${name}/actualMethod/title`]: {
    name: 'Фактический способ устранения нарушения',
    active: true,
  },
  [`/${name}/actualEliminationDate`]: {
    name: 'Фактическая дата устранения нарушения',
    active: true,
    renderFunc: renderDate,
  },

  [`/${name}/remediationPlan/plannedEliminationDates/{id}/value`]: {
    name: 'Плановая дата устранения нарушения',
    active: true,
    renderFunc: renderDate,
  },
  [`/${name}/remediationPlan/plannedMethod/{id}/title`]: {
    name: 'Планируемый способ устранения нарушения',
    active: true,
  },
  [`/${name}/remediationPlan/descriptions/{id}/value`]: {
    name: 'Пояснение инспектора к устранению нарушения',
    active: true,
  },

  [`/${name}/eliminationViolations/{id}/materialType/{id}/title`]: {
    name: 'Сведения о факте устранения нарушения - Тип материала',
    active: true,
  },
  [`/${name}/eliminationViolations/{id}/attachments/{id}/attachment/fileName`]: {
    name: 'Сведения о факте устранения нарушения - Файлы',
    active: true,
  },
  [`/${name}/eliminationViolations/{id}/descriptionGrade`]: {
    name: 'Сведения о факте устранения нарушения - Пояснение к оценке исправления',
    active: true,
  },
  [`/${name}/eliminationViolations/{id}/grade`]: {
    name: 'Сведения о факте устранения нарушения - Оценка исправления',
    active: true,
  },
  [`/${name}/eliminationViolations/{id}/actualMethod/title`]: {
    name: 'Сведения о факте устранения нарушения - Фактический способ устранения',
    active: true,
  },
  [`/${name}/eliminationViolations/{id}/descriptionMaterial`]: {
    name: 'Сведения о факте устранения нарушения - Пояснение к типу материала',
    active: true,
  },
  [`/${name}/events/{id}/event/eventType/title`]: {
    name: 'Осуществленное действие, в рамках которого выявлено нарушение',
    active: true,
  },
  // Legacy path (materials[].event) — keep for history records created before restructuring
  [`/${name}/events/{id}/materials/{id}/event/eventType/title`]: {
    name: 'Осуществленное действие, в рамках которого выявлено нарушение',
    active: true,
  },
  [`/${name}/events/{id}/materials/{id}/videoFixations/{id}/number`]: {
    name: 'Сведения о фиксации нарушений - Подтверждающий материал',
    active: true,
    renderFunc: renderConfirmingMaterialNumber,
  },
  [`/${name}/events/{id}/materials/{id}/typeDocConfirmationViolation/name`]: {
    name: 'Сведения о фиксации нарушений - Тип материала',
    active: true,
  },
  [`/${name}/events/{id}/materials/{id}/attachments/{id}/fileName`]: {
    name: 'Сведения о фиксации нарушений - Файлы',
    active: true,
  },
  [`/${name}/events/{id}/materials/{id}/links/{id}/value`]: {
    name: 'Сведения о фиксации нарушений - Ссылка на документ',
    active: true,
  },
});
